module.exports = __webpack_public_path__ + "img/pdfview.e2089ddf.png";